import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { ILoginResponse } from '../../../types';

interface ITempPasswordData {
  userData: ILoginResponse,
  oldPassword: string,
  newPassword: string,
}

export const useMutateTempPassword = () => useMutation(
  'tempPassword',
  async ({ userData, newPassword, oldPassword }: ITempPasswordData) => {
    const url = userData.authorizedUserType ? `${BASE_URL}/api/v1/user/openauth/authorized/user/${userData.authorizedUserId}/login/expiry` : `${BASE_URL}/api/v1/user/openauth/${userData.customerId}/login/expiry`;
    await httpService.post(url, {
      existingPassword: oldPassword,
      newPassword,
      loginResponseCustomData: userData.loginResponseCustomData,
    });
  },
);
